import React from 'react';
import { Button, Grid2, Paper, TextField } from '@mui/material';
import AutoComplete from '../../../BuiltInComponent/AutoComplete';

export default function ManualPurchaseItemPicker({ items = [], stage, onAdd }) {
  const itemInputRef = React.useRef(null);
  const [selected, setSelected] = React.useState(null);
  const [quantity, setQuantity] = React.useState('');
  const [rate, setRate] = React.useState('');
  const add = () => {
    if (!selected?.itemCode || Number(quantity) <= 0) return;
    const selectedItem = items.find((item) => Number(item.itemCode) === Number(selected.itemCode));
    onAdd({
      itemCode: selected.itemCode,
      itemDesc: selectedItem?.itemDesc || selected.itemDesc || '',
      quantity: Number(quantity),
      delivered: stage === 'PD' ? Number(quantity) : undefined,
      itemRate: stage === 'PI' || stage === 'PO' ? Number(rate || 0) : undefined,
      prID: null, poID: null, pdID: null
    });
    setSelected(null); setQuantity(''); setRate('');
    window.setTimeout(() => itemInputRef.current?.focus(), 0);
  };
  return <Paper variant="outlined" sx={{ width: '100%', p: { xs: 1.5, sm: 2 }, bgcolor: 'grey.50' }}>
    <Grid2 container spacing={1.5} alignItems="stretch">
      <Grid2 size={{ xs: 12, sm: 6, md: 5 }}>
        <AutoComplete inputRef={itemInputRef} label="Select Item" listData={items} value={selected} onChange={setSelected} />
      </Grid2>
      <Grid2 size={{ xs: 12, sm: 3, md: stage === 'PD' ? 3 : 2 }}>
        <TextField size="small" fullWidth label={stage === 'PD' ? 'Delivered Qty' : 'Quantity'} type="number" value={quantity} onChange={(e) => setQuantity(e.target.value)} />
      </Grid2>
      {(stage === 'PO' || stage === 'PI') && <Grid2 size={{ xs: 12, sm: 3, md: 2 }}>
        <TextField size="small" fullWidth label="Rate" type="number" value={rate} onChange={(e) => setRate(e.target.value)} />
      </Grid2>}
      <Grid2 size={{ xs: 12, sm: 12, md: 3 }}>
        <Button fullWidth variant="contained" onClick={add} disabled={!selected?.itemCode || Number(quantity) <= 0}
          sx={{ minHeight: 40, height: '100%', whiteSpace: 'nowrap' }}>
          Add Item
        </Button>
      </Grid2>
    </Grid2>
  </Paper>;
}
